import React, { Fragment, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { IC } from "../../../resources/Assets";
import { closeLayerFn, openAlertPopup, openLayerFn } from "../../Layout";
import { AppContext, defaultBs } from "../../../components/AppProvider";
import { PostApi1207, PostApi1208 } from "../../../modules/network/padoPost";
import { maxLengthCheck } from "../../../modules/utils/CheckLogic";

export default () => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const [trgtBsList, setTrgtBsList] = useState("");
  const [isDisplay, setIsDisplay] = useState("FALSE");

  const loadTargetBsList = () => {
    PostApi1208(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (res.result != "") {
            setTrgtBsList(res.result);
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    loadTargetBsList();
  }, []);

  return (
    <Fragment>
      <SectionTitle>
        목표혈당
        <BtnI />
        <p
          style={{
            float: "right",
            fontSize: "12px",
            fontWeight: "500",
            marginRight: "8px",
          }}
          onClick={() => setIsDisplay("TRUE")}>
          목표혈당 설정
        </p>
        {/* <i
          style={{
            // backgroundImage: "url(" + IC.etc.IC_SETTING_GREY + ")",
            backgroundImage: "url(" + IC.etc.IC_SETTING_GREY + ")",
            backgroundRepeat: "round",
            width: "16px",
            height: "16px",
            position: "absolute",
            right: "16px",
          }}
        /> */}
      </SectionTitle>

      <div className="full-input">
        {/* <div className="inp-with-unit"> */}
        <div style={{ position: "relative" }}>
          <div>
            <div
              style={{
                border: "1px solid #d0d0d0",
                borderRadius: "7px",
                height: "50px",
                padding: "6px 13px",
                boxShadow: "0px 5px #e1e1e1",
                display: "flex",
                alignItems: "center",
              }}>
              {/* <div style={{ width: "100%" }}> */}
              <TargetInfo
                img={IC.etc.IC_EMPTY_STOMACH}
                text={"공복혈당"}
                type="EMPTY"
                trgtBsList={trgtBsList}
              />
              <div style={{ width: "4%" }}>|</div>
              <TargetInfo
                img={IC.etc.IC_MAP_FOOD}
                text={"식후 2시간"}
                type="MAP"
                trgtBsList={trgtBsList}
              />
            </div>
          </div>
        </div>
        {/* <p style={{ paddingTop: "10px", color: "#56a6fd" }}>
          표준 당화혈색소는 4.0~6.0%를 정상으로 분류합니다.
        </p> */}
      </div>

      {isDisplay === "TRUE" && (
        <TargetBSLayer
          trgtBsList={trgtBsList}
          setTrgtBsList={setTrgtBsList}
          setIsDisplay={setIsDisplay}
        />
      )}
    </Fragment>
  );
};

const TargetInfo = props => {
  return (
    <Fragment>
      <div style={{ display: "flex", width: "48%" }}>
        <div
          className="test"
          style={{ marginTop: "30px", fontSize: "3.4vmin" }}>
          <i
            style={{
              backgroundImage: "url(" + props.img + ")",
              backgroundRepeat: "round",
              width: "28px",
              height: "28px",
              marginRight: "5px",
              marginLeft: "10px",
              position: "absolute",
              lineHeight: "50px",
              top: "8px",
            }}
          />
          {props.text}
        </div>
        <div>
          <div style={{ width: "100%", display: "flex" }}>
            <p
              style={{
                fontSize: "20px",
                fontWeight: "700",
                marginLeft: "8px",
                color: props.type === "EMPTY" ? "red" : "blue",
              }}>
              {props.trgtBsList === ""
                ? props.type === "EMPTY"
                  ? "80"
                  : "120"
                : props.type === "EMPTY"
                ? props.trgtBsList.bfMinBs == 0
                  ? defaultBs.bfMinBs
                  : props.trgtBsList.bfMinBs
                : props.trgtBsList.afMinBs == 0
                ? defaultBs.afMinBs
                : props.trgtBsList.afMinBs}
            </p>

            <p
              style={{
                fontSize: "20px",
                fontWeight: "700",
                color: props.type === "EMPTY" ? "red" : "blue",
              }}>
              ~
            </p>

            <p
              style={{
                fontSize: "20px",
                fontWeight: "700",
                color: props.type === "EMPTY" ? "red" : "blue",
                // marginLeft: "8px",
              }}>
              {props.trgtBsList === ""
                ? props.type === "EMPTY"
                  ? "120"
                  : "180"
                : props.type === "EMPTY"
                ? props.trgtBsList.bfMaxBs === 0
                  ? defaultBs.bfMaxBs
                  : props.trgtBsList.bfMaxBs
                : props.trgtBsList.afMaxBs === 0
                ? defaultBs.afMaxBs
                : props.trgtBsList.afMaxBs}
            </p>
          </div>
          <div style={{ width: "100%" }}>
            <p style={{ float: "right", fontSize: "3.4vmin" }}>mg/dL</p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
`;

const TargetBSLayer = props => {
  const { trgtBsList, setTrgtBsList, setIsDisplay } = props;
  const { userinfo, cfg, phonecfg } = useContext(AppContext);

  const request1207 = (bfMaxBs, bfMinBs, afMasBs, afMinBs) => {
    PostApi1207(userinfo, cfg, phonecfg, bfMaxBs, bfMinBs, afMasBs, afMinBs)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          // openAlertPopup("저장되었습니다.");
          request1208(userinfo, cfg);
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const request1208 = () => {
    PostApi1208(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (res.result != "") {
            setTrgtBsList(res.result);
            setIsDisplay("FALSE");
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const saveTrgtBs = () => {
    if (parseInt($("#bfMaxBs").val()) <= parseInt($("#bfMinBs").val())) {
      openAlertPopup("목표혈당값을 확인하세요.");
      return;
    }

    if (parseInt($("#afMaxBs").val()) <= parseInt($("#afMinBs").val())) {
      openAlertPopup("목표혈당값을 확인하세요.");
      return;
    }
    request1207(
      $("#bfMaxBs").val(),
      $("#bfMinBs").val(),
      $("#afMaxBs").val(),
      $("#afMinBs").val()
    );
  };

  return (
    <div
      className="blacklayer-container bloodgoal-layer"
      style={{ display: "block" }}>
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div>
          <div className="blgrn-box vertical">
            <div className="blgr-title">목표혈당 설정</div>
            <div className="under-txt">
              담당의사와 상담한 목표 혈당 수치입니다.
            </div>

            <div className="inlayer-input-halfbox2">
              <p className="hf-tit">식전 목표혈당</p>
              <div>
                <div className="inp-with-unit fat">
                  <input
                    type="number"
                    pattern="\d*"
                    className="textbox fat num"
                    id="bfMinBs"
                    onChange={e => maxLengthCheck(e, 3)}
                    style={{ color: "red" }}
                    defaultValue={
                      trgtBsList.bfMinBs === 0
                        ? defaultBs.bfMinBs
                        : trgtBsList.bfMinBs
                    }
                  />
                  <i>
                    {!userinfo.app ||
                    !userinfo.app.setInfo ||
                    !userinfo.app.setInfo.bsUnit
                      ? "mg/dl"
                      : userinfo.app.setInfo.bsUnit}
                  </i>
                </div>
              </div>
              <em>~</em>
              <div>
                <div className="inp-with-unit fat">
                  <input
                    type="number"
                    pattern="\d*"
                    className="textbox fat num"
                    id="bfMaxBs"
                    onChange={e => maxLengthCheck(e, 3)}
                    style={{ color: "red" }}
                    defaultValue={
                      trgtBsList.bfMaxBs === 0
                        ? defaultBs.bfMaxBs
                        : trgtBsList.bfMaxBs
                    }
                  />
                  <i>
                    {!userinfo.app ||
                    !userinfo.app.setInfo ||
                    !userinfo.app.setInfo.bsUnit
                      ? "mg/dl"
                      : userinfo.app.setInfo.bsUnit}
                  </i>
                </div>
              </div>
            </div>

            <div className="inlayer-input-halfbox2 btp">
              <p className="hf-tit">식후 목표혈당</p>
              <div>
                <div className="inp-with-unit fat">
                  <input
                    type="number"
                    pattern="\d*"
                    className="textbox fat num"
                    id="afMinBs"
                    onChange={e => maxLengthCheck(e, 3)}
                    style={{ color: "blue" }}
                    defaultValue={
                      trgtBsList.afMinBs === 0
                        ? defaultBs.afMinBs
                        : trgtBsList.afMinBs
                    }
                  />
                  <i>
                    {!userinfo.app ||
                    !userinfo.app.setInfo ||
                    !userinfo.app.setInfo.bsUnit
                      ? "mg/dl"
                      : userinfo.app.setInfo.bsUnit}
                  </i>
                </div>
              </div>
              <em>~</em>
              <div>
                <div className="inp-with-unit fat">
                  <input
                    type="number"
                    pattern="\d*"
                    className="textbox fat num"
                    id="afMaxBs"
                    onChange={e => maxLengthCheck(e, 3)}
                    style={{ color: "blue" }}
                    defaultValue={
                      trgtBsList.afMaxBs === 0
                        ? defaultBs.afMaxBs
                        : trgtBsList.afMaxBs
                    }
                  />
                  <i>
                    {!userinfo.app ||
                    !userinfo.app.setInfo ||
                    !userinfo.app.setInfo.bsUnit
                      ? "mg/dl"
                      : userinfo.app.setInfo.bsUnit}
                  </i>
                </div>
              </div>
            </div>

            <div className="tbns-area">
              <a
                onClick={() => setIsDisplay("FALSE")}
                className="btn-round gray">
                취소
              </a>
              <a onClick={saveTrgtBs} className="btn-round wht">
                확인
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const BtnI = styled.i`
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cpath d='m4.08 9.468 3.115-3.126L4.08 3.226l.959-.959 4.08 4.08-4.08 4.08Z'/%3E%3Cpath d='M9 12H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3ZM3.334 1.333a2 2 0 0 0-2 2v5.334a2 2 0 0 0 2 2h5.333a2 2 0 0 0 2-2V3.334a2 2 0 0 0-2-2Z'/%3E%3C/svg%3E")
    no-repeat center;
  //display:inline-block;
  width: 16px;
  height: 16px;
  margin-top: 3px;
  // position: absolute;
  float: right;
  // right: 16px;
`;